import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const actionableListRowStyles = css`
  > :first-child {
    margin-inline-end: ${theme.spacing(1)};
  }

  > :last-child {
    align-items: center;
  }
`;
